import { formatNumber } from "@wrstudios/utils";
import PropTypes from "prop-types";
import React from "react";
import {
  Bar,
  BarValue,
  Header,
  Label,
  Value
} from "./styled/live-rdc-progress-bar";

function LiveRdcProgressBar({ label, value }) {
  const maxValue = Math.min(value, 100);
  const parsedValue = `${formatNumber(maxValue, "0[.]0")}%`;

  return (
    <div>
      <Header>
        <Label>{label}</Label>
        <Value>{parsedValue}</Value>
      </Header>
      <Bar>
        <BarValue style={{ width: parsedValue }} />
      </Bar>
    </div>
  );
}

LiveRdcProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired
};

export default LiveRdcProgressBar;
